const shoppingLinkMarkets = ['de-de', 'fr-fr', 'en-gb'];
const hasIntent =
(state, intent) => Boolean(state.insights?.intents?.some((element) => element === intent));

export const storeModule = {
  namespaced: true,
  state: () => ({
    filtersShown: true,
    insights: null,
  }),
  mutations: {
    setFiltersShown(st, filtersShown) {
      st.filtersShown = filtersShown;
    },
    setInsights(st, insights) {
      st.insights = insights;
    },
  },
  actions: {
    nuxtServerInit({ commit }, context) {
      commit('setInsights', context.req.results.insights);
    },
  },
  getters: {
    hasShoppingIntent: (st) => hasIntent(st, 'shopping'),
    hasMentalHealthIntent: (st) => hasIntent(st, 'mentalHealth'),
    isShoppingLinkMarket: (st, getters, { user: { bingMarketCode } }) => (
      shoppingLinkMarkets.includes(bingMarketCode)
    ),
  },
};

export default (store) => {
  store.registerModule('search', storeModule);
};
